<div [formGroup]="form" class="wrapper">
  <kendo-gridlayout [rows]="rows" [cols]="cols" [gap]="'1rem'">
    <kendo-gridlayout-item
      *ngFor="let field of fields"
      [col]="field.col!"
      [row]="field.row!"
      [rowSpan]="field.rowSpan!"
      [colSpan]="field.colSpan!"
    >
      <kendo-formfield>
        <ng-container [ngSwitch]="field.type">
          <ng-container *ngSwitchDefault>
            <kendo-floatinglabel
              class="{{ field.fieldName }}"
              [text]="field.label | uppercase | translate"
            >
              <input
                [formControlName]="field.fieldName"
                type="text"
                kendoTextBox
              />
            </kendo-floatinglabel>
          </ng-container>
          <app-autocomplete
            class="{{ field.fieldName }}"
            [searchProp]="field.searchProp!"
            [valueName]="field.valueName!"
            [parentSearchPropValue]="field.parentPropValue"
            [formControlName]="field.fieldName"
            *ngSwitchCase="'autocomplete'"
            [label]="field.label | uppercase | translate"
          ></app-autocomplete>
          <kendo-floatinglabel
            class="{{ field.fieldName }}"
            *ngSwitchCase="'textarea'"
            [text]="field.label | uppercase | translate"
          >
            <kendo-textarea
              [formControlName]="field.fieldName"
              [resizable]="'none'"
            >
            </kendo-textarea>
          </kendo-floatinglabel>
        </ng-container>
      </kendo-formfield>
    </kendo-gridlayout-item>
  </kendo-gridlayout>
  <div class="actions">
    <!-- <button (click)="onCancel()" kendoButton>
      {{ "COMPANY_PROFILE_DATA.BUTTONS.CANCEL" | translate }}
    </button> -->
    <button (click)="onSubmit()" [primary]="true" kendoButton>
      {{ "COMPANY_PROFILE_DATA.BUTTONS.SAVE" | translate }}
    </button>
  </div>
</div>
